<template>
    <ContentOrLoading>
        <MainContent title="Editar producto" v-if="!loading">
            <template v-slot:header>
                <h3 class="card-title pb-3">Editar producto</h3>
            </template>
            <template v-slot:content>
                <FormComponent
                    :producto="producto"
                    :error="error"
                    @terminado="editarProducto()"
                    @imagenBorrada="{ error = null }"
                />
            </template>
        </MainContent>
    </ContentOrLoading>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/productos/FormComponent';

    export default {
        data() {
            return {
                loading: false,
                producto: null,
                error: null
            }
        },
        methods: {
            getProducto() {
                this.loading = true;

                const params = {
                    filters : {},
                    teatro_id: this.teatro.id,
                    product_id: this.product_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.productos.show'), params).then(res => {
                    this.producto = res.data.data;
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                }).finally(() => {
                    this.loading = false;
                });
            },
            editarProducto() {
                this.loading = true;
                this.producto.product_id = this.producto.id;
                this.producto.category_id = this.producto.categoria?.id;
                if(this.producto.subir_imagen){
                    this.producto.imagen = this.producto.subir_imagen
                }
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.productos.editar'), this.producto).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.productos.index' });
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                    this.error = error.response?.data?.errors?.imagen[0];
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        created() {
            this.getProducto();
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            product_id() {
                return this.$route.params.product_id;
            }
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>